"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var fscreen_1 = __importDefault(require("fscreen"));
var useFullscreen = function (target) {
    var _a = react_1.useState(false), fullscreen = _a[0], setFullscreen = _a[1];
    var toggleFullScreen = function () {
        var targetElem = getElement(target);
        if (!fullscreen && !!fscreen_1.default.fullscreenElement && fscreen_1.default.fullscreenElement !== targetElem) {
            fscreen_1.default.exitFullscreen();
        }
        if (!fullscreen)
            setTimeout(function () { return fscreen_1.default.requestFullscreen(targetElem); }, 300);
        else
            fscreen_1.default.exitFullscreen();
    };
    react_1.useEffect(function () {
        var detectFullScreen = function () {
            var targetElem = getElement(target);
            setFullscreen(fscreen_1.default.fullscreenElement === targetElem);
        };
        fscreen_1.default.addEventListener('fullscreenchange', detectFullScreen);
        return function () { return fscreen_1.default.removeEventListener('fullscreenchange', detectFullScreen); };
    }, [target]);
    return { fullscreen: fullscreen, toggleFullScreen: toggleFullScreen };
};
var getElement = function (target) {
    return typeof target === 'string' ? document.getElementById(target) : target;
};
exports.default = useFullscreen;
